<template>
    <div class="MessageContent" v-on:mouseleave="onLeaveMsgContent" >
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: transparent" class="message-text-container" v-on:mouseover="isActiveSuggestion = true">
            <v-avatar size="22" color="white" class="react-icon" v-if="react_icon">
              <emoji-parser :emoji="react_icon"/>
            </v-avatar>
            <!-- <emoji-parser :style="textColorStyle" class="text-pre message-text" :text="content.text" :bgColor="textMsgBgColor"/> -->
            <div class="message-text" :class="isUser ? 'user' : 'bot'">
                <span v-html="textMsgParser" class="text-pre"></span>
            </div>

            <div style="padding: 8px" v-if="content.buttons && content.buttons.length > 0">
                <button class="message-btn" v-for="(b, ib) in content.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
        <v-menu v-model="suggestionMenu" offset-x nudge-right="0" v-if="isShowSuggestionBtn">
          <template v-slot:activator="{on}">
            <v-btn icon small @click="onOpenSuggestion" class="btn-suggestion primary--text" :loading="loading">
              <icon-base :icon-color="suggestionMenu ? '#0152CC' : '#888A9A'" :icon-hover-color="suggestionMenu ? '#0152CC' : '#888A9A'">
                <icon-light-flash-line/>
              </icon-base>
            </v-btn>
          </template>
          <div class="suggestion">
            <div class="suggestion-header">
              <v-btn depressed class="text-none btn-mark-review" style="border-radius: 5px !important;" @click="onMarkReview" @mouseover="iconColor='white'" @mouseleave="iconColor='#888A9A'">
                <icon-base style="padding-right: 4px" :icon-color="iconColor" :icon-hover-color="iconColor">
                  <icon-check-fill/>
                </icon-base>
                {{$t('agentSuggestion.markToReview')}}
              </v-btn>
            </div>
            <div class="no-data" v-if="suggestions.messages && suggestions.messages.length < 1">
              <span>{{$t('agentSuggestion.noDataDisplay')}}</span>
            </div>
            <div class="suggestion-item" @click="onSelectSuggestion(msg)" v-for="msg of suggestions.messages" v-bind:key="msg.content" v-else>
              <div class="suggestion-data">
                <span><b>Intent </b> <b style="color: #19B458">({{ (msg.confidence * 100).toFixed(1) }}%)</b>: <span>{{ msg.intent }}</span></span>
              </div>
              <div class="suggestion-txt">
                {{msg.content}}
              </div>
            </div>
          </div>
        </v-menu>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";
import IconLightFlashLine from "components/icons/IconLightFlashLine";
import IconBase from "components/icons/IconBase";
import IconCheckFill from "components/icons/IconCheckFill";
import StaffService from "@/services/staff.service";
import {mapActions, mapState} from "vuex";
import {sync} from "vuex-pathify";

export default {
  name: "MessageContentText",
  components: {IconCheckFill, IconLightFlashLine, IconBase},
  data() {
    return {
      isActiveSuggestion: false,
      suggestionMenu: false,
      me: StaffService.getMe() ? StaffService.getMe() : {},
      loading: false,
      iconColor: '#888A9A'
    }
  },
  extends: MessageContent,
    computed: {
        ...mapState(['botStatus', 'supporter', 'notifyBotChat']),
        ...mapState('agentSuggestion', ['suggestions']),
        ...mapState('config', ['botConfig']),
        sample: sync('agentSuggestion/sample'),
        chosen_intent: sync('agentSuggestion/chosen_intent'),
        textMsgBgColor() {
          return this.isUser ? "#fff" : "#0052CC"
        },
        textColorStyle() {
          return this.isUser ? "color: black" : "color:white"
        },
        textMsgParser() {
          const linkParser = this.replaceLinkInTextContent(this.content.text)
          return linkParser
        //   return Twemoji.parse(linkParser, {
        //     folder: "svg",
        //     ext: ".svg",
        //   });
        },
        isShowSuggestionBtn() {
          return this.isChatWithAgent && this.isUser && !this.botStatus && this.me && this.supporter
              && this.me.id === this.supporter.id && this.isActiveSuggestion && this.botConfig['enableSuggestionForAgent']
        },
    },
  methods: {
    ...mapActions('agentSuggestion', ['agentAction', 'fetchSuggestions']),
    onLeaveMsgContent() {
      if (!this.suggestionMenu && !this.loading) {
        this.isActiveSuggestion=false
      }
    },
    onSelectSuggestion(msg) {
      this.chosen_intent =msg.intent
      this.agentAction();
      this.$EventBus.$emit(this.$EventBusType.ON_SELECT_SUGGESTION, msg.content)
    },
    onMarkReview() {
      this.chosen_intent =""
      this.agentAction(true);
    },
    onOpenSuggestion() {
      if (!this.suggestionMenu) {
        this.sample = this.content.text
        this.loading = true
        this.fetchSuggestions((err)=> {
          if (!err) {
            this.suggestionMenu = true
          }
          this.loading = false
        })
      }
    }
  },
  watch: {
    notifyBotChat(val) {
      if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE) {
        this.suggestionMenu = false;
      }
    },
    suggestionMenu() {
      this.isActiveSuggestion = this.suggestionMenu
    },
  }
}
</script>
<style scoped lang="scss">
  @import "../../style/message-box.scss";
  ::v-deep.react-icon {
    position: absolute;
    bottom: -10px;
    right: 5px;
  }
  ::v-deep.menuable__content__active {
    border-radius: 10px;
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));
    box-shadow: none !important;
  }
  .suggestion {
    background-color: #ECECF8;
    border-radius: 10px;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 1px;
    margin-left: 10px;
    :first-of-type {
      border-radius: 10px 10px 0 0 !important;
    }
    :last-of-type {
      border-radius: 0 0 10px 10px !important;
    }
    .suggestion-header {
      height: 46px;
      background-color: white;
      width: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn-mark-review {
        margin: 0 !important;
        font-size: 14px !important;
        background-color: #F6F6FB;
        color: black;
      }
      .btn-mark-review:hover {
        color: white;
        background-color: #0052CC !important;
      }
      .btn-suggestion {
        height: 30px;
        margin: 0 !important;
        border-radius: 5px !important;
        padding: 0 10px;
      }
    }
    .no-data {
      width: 500px;
      max-width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F6F6FB;
      color: #8E909F;
    }
    .suggestion-item {
      cursor: pointer;
      height: 84px;
      width: 100%;
      background-color: white;
      display: flex;
      padding: 10px;
      gap: 4px;
      flex-direction: column;
      .suggestion-data {
        display: flex;
        gap: 50px;
        color: #454545;
      }
      .suggestion-txt {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.2;
      }
    }
  }
  .suggestion-item:hover {
    background-color: #F6F6FB;
  }
</style>
